import React from "react";

import { NewsletterModal, NewsletterProps } from "@themuse/design-system";
import { triggerSnowplowImpressionEvent } from "@themuse/snowplow-js-client";
import { useLocalStorage } from "hooks/useLocalStorage";
import { newsletterSubscribeRequest, NewsletterSubmissionValues } from "utils/api";

declare global {
    interface Window {
        localStorage: any;
    }
}

const Newsletter = () => {
    const [showNewsletter, setShowNewsletter] = React.useState(false);
    const [showFormModal, setShowFormModal] = React.useState(false);
    const [userHasSubscribed, setUserHasSubscribed] = useLocalStorage("newsletter_subscription");
    const [lastClosedForm, setLastClosedForm] = useLocalStorage("newsletter_form_closed");

    const oneDayMilliseconds = 86400000;
    const newsletterHashExists = window.location.hash === "#newsletter";
    const formNotClosedInLast24Hours = Date.now() - (Date.parse(lastClosedForm) || 0) > oneDayMilliseconds;

    React.useEffect(() => {
        if ((formNotClosedInLast24Hours && !userHasSubscribed) || newsletterHashExists) {
            setShowNewsletter(true);
            let delay = 5000;
            if (newsletterHashExists) {
                delay = 500;
            }
            const timer = setTimeout(() => {
                setShowFormModal(true);
            }, delay);

            return () => clearTimeout(timer);
        }

        return () => {};
    }, []);

    const onNewsletterRefChange = (node: HTMLDivElement) => {
        if (node && !userHasSubscribed) {
            triggerSnowplowImpressionEvent(node);
        }
    };
    const onSuccessRefChange = (node: HTMLDivElement) => {
        if (node && userHasSubscribed) {
            triggerSnowplowImpressionEvent(node);
        }
    };

    const handleModalFormSubmit = async (formData: NewsletterSubmissionValues) => {
        const newsletterSuccess = await newsletterSubscribeRequest(formData);
        if (newsletterSuccess) {
            setUserHasSubscribed("true");
            setShowFormModal(false);
        }
        return newsletterSuccess;
    };

    const newsletterProps: NewsletterProps = {
        handleModalFormClose: () => {
            setLastClosedForm(new Date().toISOString());
            setShowFormModal(false);
        },
        handleModalFormSubmit,
        showFormModal,
        newsletterRef: onNewsletterRefChange,
        successRef: onSuccessRefChange
    };

    return showNewsletter ? <NewsletterModal {...newsletterProps} /> : null;
};

export { Newsletter };
